export default {"src":"/planos/_next/static/media/powering.8b0c558b.svg","height":30,"width":253,"blurWidth":0,"blurHeight":0};